<template>
    <li>
        <h4>
            <a href="#" @click.prevent="toggleShow"
                ><span :class="{ 'archive-arrow-open': showState, 'archive-arrow': true }">&#9658;</span>
                {{ year }}</a
            >
        </h4>

        <ul class="archive-list-months" v-if="showState">
            <slot></slot>
        </ul>
    </li>
</template>

<script>
export default {
    props: {
        year: Number,
        yearUrl: String,
        show: Boolean
    },

    mounted() {
        this.showState = this.show ? this.show : false;
    },

    data: function () {
        return {
            showState: false
        };
    },

    methods: {
        toggleShow: function () {
            this.showState = !this.showState;
        }
    }
};
</script>
